export const mapIcons = {
  carplay: "https://maps.google.com/mapfiles/kml/paddle/grn-circle.png",
  customer: "https://maps.google.com/mapfiles/kml/paddle/blu-circle.png",
  unselected: "images/dominos-logo-grayscale.png",
  defaultOrActive: "images/dominos-logo.png",
};
